function init() {
	const htmlEl = document.documentElement;
	const elHiddenClass = "hidden";
	const overlayOpenClass = "js-overlay-open";
	const btnActiveClass = "is-active";

	const toggleDetail = (el) => {
		el.classList.toggle(elHiddenClass);
		htmlEl.classList.toggle(overlayOpenClass);
	};

	for (const btn of document.querySelectorAll("[data-team-grid-button]")) {
		btn.addEventListener("click", () => {
			btn.classList.add(btnActiveClass);
			const el = btn.nextElementSibling;
			toggleDetail(el);
		});
	}

	for (const btn of document.querySelectorAll("[data-team-grid-detail-close]")) {
		btn.addEventListener("click", () => {
			const el = btn.closest("[data-team-grid-detail]");
			toggleDetail(el);

			// Remove active class off all trigger buttons
			for (const item of document.querySelectorAll("[data-team-grid-button]")) {
				item.classList.remove(btnActiveClass);
			}
		});
	}

	// Close modals when overlay clicked
	const overlay = document.getElementById("overlay");
	overlay.addEventListener("click", () => {
		for (const item of document.querySelectorAll("[data-team-grid-detail]")) {
			item.classList.add(elHiddenClass);
		}
		htmlEl.classList.remove(overlayOpenClass);

		// Remove active class off all trigger buttons
		for (const item of document.querySelectorAll("[data-team-grid-button]")) {
			item.classList.remove(btnActiveClass);
		}
	});
}

export default init;
